import { shallowEqual } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';
import { selectUser } from 'ducks/user/selectors';
import { AUTH, PUBLIC } from 'router/routes';
import { useAppSelector } from 'store/hooks';

import { Loading } from 'components/loading/Loading';
import { ConfirmModal } from 'components/modals/confirm/ConfirmModal';
import { ErrorModal } from 'components/modals/error/ErrorModal';
import { Navigation } from 'components/navigation/Navigation';

import { ComingSoon } from './ComingSoon';

import cn from 'templates/Template.module.scss';

export default () => {
  const { pathname, search } = useLocation();
  const { token, email_verified, two_factor, two_factor_expiration_date } = useAppSelector(
    selectUser,
    shallowEqual
  );

  if (process.env.REACT_APP_ENVIRONMENT !== 'development') {
    return <ComingSoon />;
  }

  // token is not present
  if (!token) {
    return <Navigate to={PUBLIC.LOGIN.path} state={{ referer: `${pathname}${search}` }} />;
  }

  // token is present but user is not verfied
  if (!email_verified) {
    return <Navigate to={AUTH.EMAIL.path} replace />;
  }

  // token is present but user has two factor
  if (two_factor && !two_factor_expiration_date) {
    return <Navigate to={AUTH.TWO_FACTOR.path} replace />;
  }

  return (
    <div className={cn.private}>
      <Navigation />
      <Outlet />
      <Loading />
      <ConfirmModal />
      <ErrorModal />
    </div>
  );
};
